/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React from 'react';
import Loader from '../components/loader';

export function WaitingComponent(Component: React.ComponentType) {
  return (props: any) => (
    <React.Suspense fallback={<Loader />}>
      <Component {...props} />
    </React.Suspense>
  );
}
